// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dashboard Layout */
.app-layout {
  display: flex;
  min-height: 100vh;
}

/* Stats Grid */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
  margin-bottom: 2rem;
}

@media (max-width: 1400px) {
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .stats-grid {
    grid-template-columns: 1fr;
  }
}

/* Stat Card Override */
.stat-card {
  background: linear-gradient(145deg, #1a1a2e, #16213e);
  border-radius: 16px;
  padding: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  border: 1px solid rgba(88, 101, 242, 0.15);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.stat-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #5865F2, #eb459e);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.4);
  border-color: rgba(88, 101, 242, 0.3);
}

.stat-card:hover::before {
  opacity: 1;
}

.stat-icon {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
  color: #ffffff;
  flex-shrink: 0;
}

.stat-content h3 {
  font-size: 1.85rem;
  margin: 0;
  font-weight: 700;
  color: #ffffff;
}

.stat-content p {
  color: #8b8b9a;
  margin: 0.35rem 0 0 0;
  font-size: 0.9rem;
}

/* Dashboard Grid */
.dashboard-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
}

@media (max-width: 1200px) {
  .dashboard-grid {
    grid-template-columns: 1fr;
  }
}

/* Dashboard Section */
.dashboard-section {
  background: linear-gradient(145deg, #1a1a2e, #16213e);
  border-radius: 16px;
  padding: 1.5rem;
  border: 1px solid rgba(88, 101, 242, 0.15);
}

.dashboard-section h2 {
  font-size: 1.15rem;
  margin-bottom: 1.25rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #ffffff;
  font-weight: 600;
}

/* Recent Links */
.recent-links,
.top-authors {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.link-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.875rem 1rem;
  background: rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  transition: all 0.2s ease;
}

.link-item:hover {
  background: rgba(88, 101, 242, 0.1);
  border-color: rgba(88, 101, 242, 0.2);
  transform: translateX(4px);
}

.link-category {
  font-size: 1.25rem;
  width: 36px;
  text-align: center;
}

.link-info {
  flex: 1 1;
  min-width: 0;
}

.link-info a {
  color: #5865F2;
  text-decoration: none;
  font-size: 0.9rem;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: color 0.2s ease;
}

.link-info a:hover {
  color: #7c8af8;
  text-decoration: underline;
}

.link-meta {
  color: #6b6b7b;
  font-size: 0.8rem;
  margin-top: 0.25rem;
}

/* Author Item */
.author-item {
  display: flex;
  align-items: center;
  gap: 0.875rem;
  padding: 0.875rem 1rem;
  background: rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  transition: all 0.2s ease;
}

.author-item:hover {
  background: rgba(88, 101, 242, 0.1);
  border-color: rgba(88, 101, 242, 0.2);
}

.author-rank {
  width: 28px;
  height: 28px;
  background: linear-gradient(135deg, #5865F2, #4752c4);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 0.8rem;
  color: #ffffff;
}

.author-item:nth-child(1) .author-rank {
  background: linear-gradient(135deg, #ffd700, #ffb700);
  color: #1a1a2e;
}

.author-item:nth-child(2) .author-rank {
  background: linear-gradient(135deg, #c0c0c0, #a0a0a0);
  color: #1a1a2e;
}

.author-item:nth-child(3) .author-rank {
  background: linear-gradient(135deg, #cd7f32, #b8722c);
  color: #ffffff;
}

.author-info {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #ffffff;
  font-size: 0.9rem;
}

.author-info svg {
  color: #5865F2;
  font-size: 0.85rem;
}

.author-count {
  color: #8b8b9a;
  font-size: 0.8rem;
  font-weight: 500;
}

/* No Data */
.no-data {
  text-align: center;
  color: #6b6b7b;
  padding: 2rem;
  font-size: 0.9rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Dashboard.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,uBAAuB;AACvB;EACE,qDAAqD;EACrD,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oDAAoD;EACpD,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,sBAAsB;AACtB;EACE,qDAAqD;EACrD,mBAAmB;EACnB,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;;EAEE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,+BAA+B;EAC/B,mBAAmB;EACnB,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,mBAAmB;EACnB,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,iBAAiB;AACnB","sourcesContent":["/* Dashboard Layout */\n.app-layout {\n  display: flex;\n  min-height: 100vh;\n}\n\n/* Stats Grid */\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n@media (max-width: 1400px) {\n  .stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .stats-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Stat Card Override */\n.stat-card {\n  background: linear-gradient(145deg, #1a1a2e, #16213e);\n  border-radius: 16px;\n  padding: 1.5rem;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  border: 1px solid rgba(88, 101, 242, 0.15);\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.stat-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: linear-gradient(90deg, #5865F2, #eb459e);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.stat-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.4);\n  border-color: rgba(88, 101, 242, 0.3);\n}\n\n.stat-card:hover::before {\n  opacity: 1;\n}\n\n.stat-icon {\n  width: 56px;\n  height: 56px;\n  border-radius: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.4rem;\n  color: #ffffff;\n  flex-shrink: 0;\n}\n\n.stat-content h3 {\n  font-size: 1.85rem;\n  margin: 0;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.stat-content p {\n  color: #8b8b9a;\n  margin: 0.35rem 0 0 0;\n  font-size: 0.9rem;\n}\n\n/* Dashboard Grid */\n.dashboard-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1.5rem;\n}\n\n@media (max-width: 1200px) {\n  .dashboard-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Dashboard Section */\n.dashboard-section {\n  background: linear-gradient(145deg, #1a1a2e, #16213e);\n  border-radius: 16px;\n  padding: 1.5rem;\n  border: 1px solid rgba(88, 101, 242, 0.15);\n}\n\n.dashboard-section h2 {\n  font-size: 1.15rem;\n  margin-bottom: 1.25rem;\n  padding-bottom: 0.75rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #ffffff;\n  font-weight: 600;\n}\n\n/* Recent Links */\n.recent-links,\n.top-authors {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.link-item {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 0.875rem 1rem;\n  background: rgba(0, 0, 0, 0.25);\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  transition: all 0.2s ease;\n}\n\n.link-item:hover {\n  background: rgba(88, 101, 242, 0.1);\n  border-color: rgba(88, 101, 242, 0.2);\n  transform: translateX(4px);\n}\n\n.link-category {\n  font-size: 1.25rem;\n  width: 36px;\n  text-align: center;\n}\n\n.link-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.link-info a {\n  color: #5865F2;\n  text-decoration: none;\n  font-size: 0.9rem;\n  display: block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  transition: color 0.2s ease;\n}\n\n.link-info a:hover {\n  color: #7c8af8;\n  text-decoration: underline;\n}\n\n.link-meta {\n  color: #6b6b7b;\n  font-size: 0.8rem;\n  margin-top: 0.25rem;\n}\n\n/* Author Item */\n.author-item {\n  display: flex;\n  align-items: center;\n  gap: 0.875rem;\n  padding: 0.875rem 1rem;\n  background: rgba(0, 0, 0, 0.25);\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  transition: all 0.2s ease;\n}\n\n.author-item:hover {\n  background: rgba(88, 101, 242, 0.1);\n  border-color: rgba(88, 101, 242, 0.2);\n}\n\n.author-rank {\n  width: 28px;\n  height: 28px;\n  background: linear-gradient(135deg, #5865F2, #4752c4);\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 0.8rem;\n  color: #ffffff;\n}\n\n.author-item:nth-child(1) .author-rank {\n  background: linear-gradient(135deg, #ffd700, #ffb700);\n  color: #1a1a2e;\n}\n\n.author-item:nth-child(2) .author-rank {\n  background: linear-gradient(135deg, #c0c0c0, #a0a0a0);\n  color: #1a1a2e;\n}\n\n.author-item:nth-child(3) .author-rank {\n  background: linear-gradient(135deg, #cd7f32, #b8722c);\n  color: #ffffff;\n}\n\n.author-info {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #ffffff;\n  font-size: 0.9rem;\n}\n\n.author-info svg {\n  color: #5865F2;\n  font-size: 0.85rem;\n}\n\n.author-count {\n  color: #8b8b9a;\n  font-size: 0.8rem;\n  font-weight: 500;\n}\n\n/* No Data */\n.no-data {\n  text-align: center;\n  color: #6b6b7b;\n  padding: 2rem;\n  font-size: 0.9rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
